// @ts-nocheck
import React, { useMemo } from 'react';
import intl from 'react-intl-universal';
import { Button, ButtonGroup, Intent, Menu, MenuDivider, MenuItem } from '@blueprintjs/core';
import { Icon } from '@/components';
import { safeCallback } from '@/utils';
import styled from 'styled-components';

const StatusBadge = styled.span<{ status: string }>`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${({ status }) =>
    status?.toLowerCase() === 'active' ? '#f6ffed' : '#fff2f0'};
  color: ${({ status }) =>
    status?.toLowerCase() === 'active' ? '#52C41A' : '#FF0000'};
`;

function StatusCell({ cell: { value } }) {
  return <StatusBadge status={value}>{value}</StatusBadge>;
}

export function ActionMenuList({
  row: { original },
  payload: { onEditShippingAccount, onDeleteShippingAccount },
}) {
  return (
    <Menu>
      <MenuItem
        icon={<Icon icon="pen-18" />}
        text={intl.get('edit_shipping_account')}
        onClick={safeCallback(onEditShippingAccount, original)}
      />
      <MenuDivider />
      <MenuItem
        icon={<Icon icon="trash-16" iconSize={16} />}
        text={intl.get('delete_shipping_account')}
        onClick={safeCallback(onDeleteShippingAccount, original)}
        intent={Intent.DANGER}
      />
    </Menu>
  );
}

function ActionsCell({
  row: { original },
  payload: { onEditShippingAccount, onDeleteShippingAccount },
}) {
  return (
    <ButtonGroup minimal={true}>
      <Button
        icon={<Icon icon="pen-18" iconSize={13} />}
        minimal={true}
        onClick={safeCallback(onEditShippingAccount, original)}
        style={{ marginRight: '5px', background: 'none'}}
      />
      <Button
        intent={Intent.DANGER}
        icon={<Icon icon="trash" iconSize={13} />}
        minimal={true}
        onClick={safeCallback(onDeleteShippingAccount, original)}
        style={{ background: 'none' }}
      />
    </ButtonGroup>
  );
}

export function useShippingAccountsTableColumns() {
  return useMemo(
    () => [
      {
        Header: 'Carrier',
        accessor: 'carrier.name',
        width: 140,
      },
      {
        Header: 'Customer',
        accessor: 'customer.display_name',
        width: 140,
      },
      {
        Header: 'Description',
        accessor: 'description',
        width: 200,
        textOverview: true,
      },
      {
        Header: 'Account #',
        accessor: 'account_number',
        width: 160,
      },
      {
        Header: 'Sequence',
        accessor: 'sequence',
        width: 90,
      },
      {
        Header: 'Status',
        accessor: 'status',
        Cell: StatusCell,
        width: 100,
      },
      {
        id: 'actions',
        Header: 'Actions',
        Cell: ActionsCell,
        className: 'actions',
        width: 100,
        disableResizing: true
      },
    ],
    [],
  );
}